import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination , FreeMode } from 'swiper/modules';

function clientlogos() {
    const client_logo_slider = document.querySelector('[data-target="client_logo_slider"]');
    const clients_intro = document.querySelector('[data-target="clients_intro"]');
    
    if (!client_logo_slider) { return; }

    const clients = document.querySelectorAll('.home [data-block="clients"]');

const slider = new Swiper ('[data-target="client_logo_slider"]', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 2.5,
    spaceBetween: 10,
    breakpoints: {
        1024: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        
    },
   
    loop: true,
    autoplay: {
        delay: 0,
    },
    speed: 5000,
    allowTouchMove: false,
       
    }); 
    
    

    
   
    gsap.from(clients, {
        autoAlpha: 0,
        duration: 1,
        scrollTrigger: {
            trigger: clients,
            start:'top bottom'
        
        },
    });
      
}


export { clientlogos }; 